<template>
    <div>
        <div v-bind:style="viewerContent" id="viewerDiv">
            <header class="w100" id="header" style="background: #4D4D4D;padding: 8px 2px;">
                <div class="d-flex justify-content-start">
                    <div class="mr-auto pr-2 align-self-center">
                        <div class="text-truncate">
            <a class="header-back" v-bind:href="getMangahotDetailUrl(workCode, restoreToken, timeRes, pid)">
              <img src="/koreyomo/static/assets/images/arrow_left.png" width="30" height="30" ><span class="header-back" style="font-size:16px;">作品詳細へ戻る</span>
                            </a>
                        </div>
                    </div>


                    <div class="align-self-right" style="color:white;">
                        <!-- <button v-show="recommendRankingWorks.length > 0" data-toggle="modal"
                      data-target="#modalRecommend" style="width:100%;" class="btn btn-modal">おすすめ結果を 再チェック</button> -->
                        <img class="w-auto mr-2"
                             src="/koreyomo/static/assets/images/mai_part-20.png"
                             width="120" height="40"
                             v-show="recommendRankingWorks.length > 0 && mangaJp"
                             v-on:click="showpopupMobile"
                        />
                    </div>
                </div>
            </header>

            <div class="contents">
                <div id="comic-viewer" v-bind:style="contentsAreaStyle">
                    <!-- Right page -->
        <div id="comic-page-right" class="page-contents" v-bind:style="rightPageStyle" v-on:click="clickLeftPage">
                        <ViewerLastPageMobile
                                v-if="ViewerLastPageLoaded"
                                v-show="shouldShowLastPage(rightPageType)"
                                v-bind:work-info="workInfo"
                                v-bind:next-story-item="nextStoryItem"
                                v-bind:recommend-items="recommendItems"
                                v-bind:work-background-color="workBackgroundColor"
                                v-bind:restore-token="restoreToken"
                                v-bind:time-res="timeRes"
                                v-bind:pid="pid"
                        />

                        <img id="comic-arrow-left"
                             class='comic-page-arrow'
                             src="/koreyomo/static/assets/images/arrow_left.png"
                             v-bind:style="leftArrowStyle"
                             v-show="showLeftArrow"/>
                        <CoverPage v-show="shouldShowCover(rightPageType)"
                                   v-bind:catch-phrase="catchPhrase"
                                   v-bind:work-name="workName"
                                   v-bind:author-name="authorName"
                                   v-bind:story-title="storyTitle"/>
                        <AdvertisementPage v-show="shouldShowAdvertisement(rightPageType)"/>
                        <ComicPage v-show="shouldShowComic(rightPageType)"
                                   v-bind:image-list="leftImages"
                                   v-bind:image-index="leftImageIndex"/>

                        <img id="comic-arrow-right"
                             class='comic-page-arrow'
                             src="/koreyomo/static/assets/images/arrow_right.png"
                             v-bind:style="rightArrowStyle"
                             v-show="showRightArrow"/>
                    </div>

                    <!-- Left page -->
        <div id="potraitButton" v-on:click="hideButton" v-show="showButton && recommendRankingWorks.length > 0" class="btn btn-floating" style="background:#ff475d">
                        最新話まで読むならアプリへ
          <img class="btn-close" src="/koreyomo/static/assets/images/close_pink.png" height="18" width="18" 
                             v-show="showButton && recommendRankingWorks.length > 0">
                    </div>

                </div>

            </div>


            <footer id="footer">
                <div class="d-flex flex-row py-3" style="padding-left:3%;padding-right:3%;height:70px;">
                    <input id="slider-page"
                           type="range" min="0" v-bind:max="lastPageIndex" v-model.number="currentPageIndex"
                           key="input-page-index"
                           step="1"
                           class="slider-rtl slider-color slider-viewer align-self-center"
                           style="background:#afafaf;">
                </div>
            </footer>
        </div>


        <div id="popupMobile" style="position:fixed;top:0;width:100%;display:none;">
            <header class="w100" style="background: #4D4D4D;padding: 8px 10px;">
                <div class="d-flex justify-content-start">
                    <div class="mr-auto pr-2 align-self-center">
                        <div class="text-truncate">
            <a class="header-back" v-bind:href="getMangahotDetailUrl(workCode, restoreToken, timeRes, pid)">
              <img src="/koreyomo/static/assets/images/arrow_left.png" width="30" height="30" ><span class="header-back">作品詳細へ戻る</span>
                            </a>
                        </div>
                    </div>

                    <div class="mr-2" v-on:click="hidepopupMobile" style="display:flex;align-items: center;">
          <img src="/koreyomo/static/assets/images/close_white.png" height="18" width="18" v-on:click="hidepopupMobile">
                    </div>
                </div>
            </header>

            <div class="container-fluid p-0" style="min-height:500px;">
                <div v-bind:style="backgroundStyle">
                    <RecommendPanel v-bind:ranking-works="recommendRankingWorks"
                                    v-bind:persona-text="recommendPersonaText"
                                    v-bind:work-info="topWorkItem"
                                    v-bind:persona-id="pid"
                                    v-bind:time-res="timeRes"
                                    v-bind:restore-token="restoreToken"
                                    v-bind:read-pages="currentPageIndex"
                                    v-bind:total-pages="numberOfPages"/>

                    <div class="d-flex-end p-2" style="text-align:right;" :style="backgroundStyle">
                        <router-link
                                :style="textStyle"
                                :key="$route.fullPath"
                                :to="{ path: '/recommend', query: { m: 2, rt: restoreToken, timeres: timeRes, pid: pid }}">
                            おすすめ結果へ戻る
                        </router-link>
                    </div>
                </div>
            </div>

        </div>


    </div>
</template>

<script>
    import _ from 'lodash'
    import App from "../App";
    import * as consts from '../constants';
    import * as Api from '../api/apies6.js';
    import CoverPage from "../components/CoverPage";
    import BlankPage from "../components/BlankPage";
    import AdvertisementPage from "../components/AdvertisementPage";
    import ViewerLastPageMobile from "../components/ViewerLastPageMobile";
    import RecommendPanel from "../components/RecommendPanel";
    import ComicPage from "../components/ComicPage";
    import dynamicStyleMixin from "../components/DynamicStyleMixin";

    const PAGE_TYPE_COMIC = 1
    const PAGE_TYPE_COVER = 2
    const PAGE_TYPE_BLANK = 3
    const PAGE_TYPE_ADVERTISEMENT = 4
    const PAGE_TYPE_VIEWER_LAST_PAGE = 5

    const MIN_CONTENT_WIDTH = 100
    const MIN_CONTENT_HEIGHT = 520

    export default {
        name: "ViewerMobile",
        components: {ComicPage, RecommendPanel, ViewerLastPageMobile, AdvertisementPage, BlankPage, CoverPage, App},
        mixins: [dynamicStyleMixin],
        data() {
            return {
                /** @type {KoreyomoStoryResult} */
                storyResult: new Api.KoreyomoStoryResult(),

                workBackgroundColor: "#000000",
                catchPhrase: "",
                workName: "",
                authorName: "",
                storyTitle: "",
                lastPageWorkImageUrl: "",

                restoreToken: null,
                timeRes: null,
                pid: null,

                /** @type {KoreyomoWorkInfo} */
                workInfo: null,
                nextStoryItem: null,
                recommendItems: [],

                recommendRankingWorks: [],
                recommendPersonaText: "",

                /** @type {Array.<string>} Array of content URLs */
                contentUrls: [],

                // The page number on the left side currently displayed. zero-based index.
                currentPageIndex: 0,

                // Size excluding header and footer.
                contentsWidth: 0,
                contentsHeight: 0,

                orgContentsWidth: 0,
                orgContentsHeight: 0,

                // The comic image is fixed at 1080 x 1536 pixels.
                // If it is changed, it must be obtained dynamically from image.
                originalImageWidth: 1080,
                originalImageHeight: 1536,

                imageWidth: 0,
                imageHeight: 0,
                imageOffsetXOfLeftPage: 0,
                imageOffsetXOfRightPage: 0,
                imageOffsetY: 0,
                showButton: true,
                showLeftArrow: false,
                showRightArrow: false,
                opacity: 1,

                btnbackground: '#ff475d',
                btnposition: 'absolute',
                btnwidth: '70%',
                btnmarginLeft: '15%',
                btnmarginRight: '15%',
                btnborderRadius: '10px',
                btncolor: 'white',
                btnbottom: '-90px',
                topWorkItem: null,
                clickWidth: '',
                shareTextTwitter: 'Koreyomo',
                shareTextFB: 'Koreyomo',
                ViewerLastPageLoaded: false,
                recommendWorksFromWorksData: [],
                mobileHeight: '',
                mobileWidth: '',
                orgContentsHeight: '',
                mangaJp: true
            }
        },
        computed: {
            workCode: function () {
                return this.workInfo ? this.workInfo.workCode : ""
            },

            // Content area is the area excluding header and footer.
            contentsAreaStyle: function () {
                return {
                    'width': this.contentsWidth + 'px',
                    'height': this.contentsHeight + 'px',
                    'position': 'relative',
                    'margin': '0 auto'
                }
            },

            viewerContent: function () {
                return {
                    'width': this.mobileWidth + 'px',
                    'height': this.mobileHeight + 'px',
                    'margin': '0 auto'
                }
            },

            contentModal: function () {
                return {
                    'width': this.contentsWidth + this.contentsWidth * 1 / 100 + 'px',
                    'margin': 0,
                }
            },
            leftPageStyle: function () {
                return {
                    // 'position': 'absolute',
                    // 'left': this.imageOffsetXOfLeftPage + 'px',
                    // 'top': this.imageOffsetY + 'px',
                    'width': this.imageWidth + 'px',
                    'height': this.imageHeight + 'px'
                }
            },
            rightPageStyle: function () {
                return {
                    'width': '100%',
                    'height': '100%'
                }
            },
            btnFloating: function () {
                return {
                    // 'width': '100%',
                    // 'height': '100%'
                    'background': this.btnbackground,
                    'position': this.btnposition,
                    'width': this.btnwidth,
                    'marginLeft': this.btnmarginLeft,
                    'marginRight': this.btnmarginRight,
                    'borderRadius': this.btnborderRadius,
                    'color': this.btncolor,
                    'bottom': this.btnbottom
                }
            },
            leftArrowStyle: function () {
                return {
                    'position': 'absolute',
                    'left': '6px',
                    'top': '50%',
                    'z-index': '999'
                }
            },
            rightArrowStyle: function () {
                return {
                    'position': 'absolute',
                    'right': '6px',
                    'top': '50%',
                }
            },

            numberOfPages: function () {
                return this.contentUrls.length
            },
            lastPageIndex: function () {
                let page = (this.numberOfPages - 1);
                this.$cookies.set('feedbacktotalPages', page, '100MIN');
                page += 3
                return page
            },
            leftImageIndex: function () {
                return this.currentPageIndex - 1
            },
            leftImages: function () {
                let result = []
                for (let i = 0; i < this.contentUrls.length; i += 2) {
                    let url = this.urlAtIndex(i)
                    if (url !== null) {
                        result.push(url);
                    }
                }
                return this.contentUrls
            },

            rightPageType: function () {
                this.$cookies.set('feedbackcurrentPageIndex', this.currentPageIndex, '100MIN');
                if (this.currentPageIndex === 0) {
                    //this.contentsHeight = this.orgContentsHeight-160;
                    return PAGE_TYPE_COVER
                }
                this.contentsHeight = this.orgContentsHeight;
                // When the number of pages is an even number, one page remains.
                // In this case, the left page is blank and the right page is the last of the comic.
                if (this.currentPageIndex >= this.numberOfPages + 1) {
                    if (this.currentPageIndex + 1 === this.lastPageIndex) {
                        return PAGE_TYPE_ADVERTISEMENT
                    } else {
                        return PAGE_TYPE_VIEWER_LAST_PAGE
                    }
                }
                return PAGE_TYPE_COMIC
            },
            styleObject: function () {
                return this.topWorkItem
            },
        },
        methods: {
            onOrientationchange: _.throttle(function () {
                this.clickWidth = $(window).height()
            }, 100),
            detectOrientationMode: _.throttle(function () {
                if (window.orientation == 0) {
                    // this.contentsHeight = $(window).height();
                    this.contentsWidth = this.clickWidth = $(window).width();
                    this.orgContentsHeight = this.contentsHeight = $(window).width() * 1.42222;

                    this.mobileHeight = $(window).height()
                    this.mobileWidth = $(window).width()
                }
                else {
                    // this.contentsHeight = this.clickWidth = $(window).width();
                    this.clickWidth = $(window).width();
                    this.contentsWidth = $(window).height();
                    this.orgContentsHeight = this.contentsHeight = $(window).height() * 1.42222;

                    this.mobileHeight = $(window).width();
                    this.mobileWidth = $(window).height();
                }
            }, 10),

            urlAtIndex(index) {
                let urls = this.contentUrls
                if (index < 0 || index >= urls.length) {
                    return null;
                }
                return urls[index]
            },
            layoutContent() {
                this.contentsHeight = $(window).height();
                this.contentsWidth = $(window).width();
            },
            clickLeftPage(event) {
                let className = event.target.className
                if (className.includes('btn btn-read')) {
                    return false;
                }
//        let curPage = this.currentPageIndex + 1
                if (this.lastPageIndex == this.currentPageIndex) {
                    this.gtagFunction(consts.HIT_TYPE.PAGE_VIEW, consts.EVENT_CATEGORY.VIEWER, document.title + consts.EVENT_LABEL.LAST_PAGE_POST, 'no');
                }
                // Next page
                if (event.target.id != "lastPageImage") {
                    var leftPart = this.clickWidth / 2 - 100;
                    var rightPart = this.clickWidth / 2 + 100
                    if (event.clientX > rightPart) {
                        if (this.currentPageIndex > 0) {
                            this.currentPageIndex = Math.min(this.currentPageIndex - 1, this.lastPageIndex)
                            if (!$("#header").is(":hidden") && this.lastPageIndex != this.currentPageIndex) {
                                this.showButton = true;
                                $("#potraitButton").css({'bottom': '-16px'})
                                $("#header,#footer").show();
                                $('#viewerDiv').removeClass('vertical-align');
                            }
                        }
                    } else if (event.clientX < leftPart) {
                        this.currentPageIndex = Math.min(this.currentPageIndex + 1, this.lastPageIndex)
                        if (!$("#header").is(":hidden") || this.lastPageIndex == this.currentPageIndex) {
                            $("#potraitButton").css({'bottom': '-16px'})
                            $("#header,#footer").show();
                            $('#viewerDiv').removeClass('vertical-align');
                            this.showButton = true;
                        }
                    } else {
                        if ($("#header").is(":hidden")) {
                            $("#potraitButton").css({'bottom': '-16px'});
                            $('#comic-arrow-left,#comic-arrow-right').fadeIn()
                            $("#header,#footer").show();
                            this.showButton = true;
                            $('#viewerDiv').removeClass('vertical-align');
                        }
                        else {
                            if (this.lastPageIndex != this.currentPageIndex) {
                                $("#potraitButton").css({'bottom': '40px'})
                                $("#header,#footer").hide();
                                this.hideNavigationButton();
                                $('#viewerDiv').addClass('vertical-align');
                                this.showButton = false;
                            }
                        }

                    }
                }


        
            },

            hasFocusPageSlider() {
                let hasFocus = $('#slider-page').is(':focus');
                return hasFocus
            },
            hideNavigationButton() {
                $('#comic-arrow-left').fadeOut()
                $('#comic-arrow-right').fadeOut()
                if (this.lastPageIndex != this.currentPageIndex) {
                    $("#potraitButton").css({'bottom': '40px'})
                    $("#header,#footer").hide();
                    $('#viewerDiv').addClass('vertical-align');
                    this.showButton = false;
                }

            },
            async doGet() {
                let workCode = this.$route.params.workCode
                let storyId = this.$route.params.storyId

                let api = new Api.KoreyomoApi(this.getApiConfig())
                let result = await api.worksStoryDetailWorkCodeStoryIdGetAsync(workCode, storyId)

                this.contentUrls = result.content.contentUrls

                this.workBackgroundColor = result.workInfo.backgroundColor
                this.catchPhrase = result.workInfo.catchPhrase
                this.workName = result.workInfo.workName
                this.authorName = result.workInfo.authorName
                this.storyTitle = result.storyItem.storyTitle
                this.lastPageWorkImageUrl = result.workInfo.bannerLargeImageUrl

                this.workInfo = result.workInfo
                this.nextStoryItem = result.nextStoryItem
                this.recommendItems = result.recommendWorks


                document.title = "無料試し読み、" + result.workInfo.workName + " " + result.storyItem.storyTitle + " | マンガほっと";
                document.getElementsByTagName('meta')["description"].content = result.workInfo.catchPhrase + " | " + result.workInfo.workName;

                this.gtagFunction(consts.HIT_TYPE.PAGE_VIEW, consts.EVENT_CATEGORY.VIEWER, document.title + consts.EVENT_LABEL.VIEWER_POST, 'no');

                let resultRecommends = await api.worksRecommendWorksFromWorksGetAsync(this.workInfo.workCode)
                this.restoreToken = this.$route.query.rt;
                if (this.restoreToken != '' || this.restoreToken.length > 0) {
                    let resultRecommends = await api.worksRecommendWorksFromTokenGetAsync(this.restoreToken)
                    this.recommendWorksFromWorksData = resultRecommends
                    this.recommendPersonaText = resultRecommends.maiResult.personaText
                    this.recommendRankingWorks = resultRecommends.rankingWorks
                    this.topWorkItem = resultRecommends.topWorkItem;
                    this.shareTextTwitter = '「' + this.workInfo.workName + '」 をおすすめします！試し読み⇒'
                    this.shareTextFB = '「' + this.recommendWorksFromWorksData.rankingWorks[0].workName + '」| マンガほっと'
                } else {
                    this.recommendWorksFromWorksData = []
                    this.recommendPersonaText = ""
                    this.recommendRankingWorks = []
                    this.topWorkItem = null;
                    this.shareTextTwitter = '「' + this.workInfo.workName + '」 をおすすめします！試し読み⇒'
                    this.shareTextFB = ''
                }
                this.ViewerLastPageLoaded = true;

            },
            shouldShowComic(type) {
                return type === PAGE_TYPE_COMIC
            },
            shouldShowCover(type) {
                return type === PAGE_TYPE_COVER
            },
            shouldShowBlank(type) {
                return type === PAGE_TYPE_BLANK
            },
            shouldShowAdvertisement(type) {
                // console.log(type);
                return type === PAGE_TYPE_ADVERTISEMENT
            },
            shouldShowLastPage(type) {
                return type === PAGE_TYPE_VIEWER_LAST_PAGE
            },
            hideButton() {
                var className = event.srcElement.className;
                if (className == "btn btn-floating") {
                    window.location.href = "https://go.onelink.me/taMo?pid=media&c=koreyomo";
                }
                else {
                    this.showButton = false;
                }
            },
            showpopupMobile: function () {
                // this.opacity = 0.3;
                $("#viewerDiv").css({'opacity': '0.3'})
                $('#popupMobile').show('slide', {direction: 'up'}, 500);
                $('#viewerDiv').css('pointer-events', 'none');
                // $('#slider-page').slider({ disabled: true });
            },
            hidepopupMobile: function () {
                $('#popupMobile').hide('slide', {direction: 'up'}, 500);
                $('#viewerDiv').css('pointer-events', 'auto');
                $("#viewerDiv").css({'opacity': '1'})
            }
        },
        async created() {
            let self = this
            await self.doGet()

            $('meta[property=og\\:title]').attr('content', this.shareTextFB);
            $('meta[property=og\\:description]').attr('content', this.catchPhrase);
            $('meta[property=og\\:site_name]').attr('content', 'マンガほっと');

            window.addEventListener('resize', self.onResize, false);
            window.addEventListener('keydown', self.onKeyDown, false)
            window.addEventListener('orientationchange', self.onOrientationchange, false);
            window.addEventListener('load', self.detectOrientationMode, false);

            self.showLeftArrow = true;
            self.showRightArrow = true;
            // Apply custom background color.
            $('#modalRecommend').on('shown.bs.modal', function (e) {
                self.gtagFunction(consts.HIT_TYPE.PAGE_VIEW, consts.EVENT_CATEGORY.VIEWER, consts.EVENT_LABEL.RECOMMEND_MODAL, 'no');
                $('body').addClass('modal-recommend-open');
            }).on('hidden.bs.modal', function (e) {
                $('body').removeClass('modal-recommend-open');
            });

            setTimeout(self.hideNavigationButton, 4000);

            // First update the layout.
            self.$nextTick(() => {
                self.detectOrientationMode()
            })
            self.$cookies.set('feedbackworkCode', self.$route.params.workCode, '100MIN');
            self.$cookies.set('feedbackstoryId', self.$route.params.storyId, '100MIN');
            self.$cookies.set('feedbackpid', self.$route.query.pid, '100MIN');
            self.$cookies.set('feedbacktimeRes', self.$route.query.timeres, '100MIN');
            let rt = self.$route.query.rt
            if (rt == '' || rt.length < 1) {
                self.mangaJp = false
            }
        },
        beforeDestroy: function () {
            window.removeEventListener('keydown', this.onKeyDown, false)
            window.removeEventListener('resize', this.onResize, false);
            window.removeEventListener('orientationchange', this.onOrientationchange, false);
            window.removeEventListener('load', this.detectOrientationMode, false);
        },
        watch: {
            "$route.params.storyId"(val) {
                // TODO: It is necessary to consider whether there is a problem with the implementation of the reload.
                location.reload()
            }
        }

    }
</script>

<style scoped>
    footer {
        background-color: #4D4D4D;
    }

    .contents {
        margin: 0;
        background-color: #4D4D4D;
    }

    #comic-viewer {
        position: absolute;
        bottom: 0;
    }

    .comic-page {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
    }

    .comic-page-arrow {
        position: absolute;
        width: 50px;
        height: 50px;
        margin-top: -25px;

        /* Background circle */
        background-color: rgba(0, 0, 0, 0.5);
        border-radius: 50%;
        padding: 8px;
    }

    .slidecontainer {
        width: 100%;
    }

    .slider-rtl {
        direction: rtl
    }

    .slider-viewer {
        border-radius: 10px;
    }

    .slider-viewer::-webkit-slider-thumb {
        /* background: #B2B2B2; */
        background: white !important;

    }

    .slider-viewer::-moz-range-thumb {
        /* background: #B2B2B2; */
        background: white !important;
    }

    input[type=range]::-ms-thumb {
        /* background: #B2B2B2; */
        background: white !important;
    }

    .footer {
        background-color: #4D4D4D
    }

    .btn-floating {
        background: #ff475d;
        position: absolute;
        width: 70%;
        margin-left: 15%;
        margin-right: 15%;
        border-radius: 10px;
        color: white;
        bottom: -16px;
    }

    .btn-close {
        position: absolute;
        /* border-radius: 50%;
        border: 2px solid #ff475d;
        width: 26px;
        height: 24px;
        padding-bottom: 23px;
        background: white;
        color: #ff475d; */
        right: -10px;
        top: -8px;
        z-index: 9999;
    }

    .btn-modal {
        width: 70% !important;
        background: #afafaf;
        color: white;
        float: right;
        border-radius: 10px;
        padding: 2px 8px;
    }

    .btn:focus {
        outline: none;
        box-shadow: none !important;
    }

    .removeBlankSpace {
        position: absolute !important;
        bottom: 0px,
    }

    @media screen and (max-width: 320px) {
        .btn-floating {
            font-size: 12px;
        }
    }


</style>




// WEBPACK FOOTER //
// src/pages/ViewerMobile.vue